import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { PagingResponse } from '@models/paging-response.model';
import { UserConfigsService } from './user-configs.service';
import { ErrorHandlerService } from './error-handler.service';
import { CasePriority } from '../models/case-priority.model';
import { StringUtility } from '../utilities/string.utility';

@Injectable({
	providedIn: 'root'
})
export class CasePriorityService {
	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService, private userConfigService: UserConfigsService) { }

	getCasePriorities(pageIndex: number, pageSize: number, searchTerm?: string): Observable<any | PagingResponse<CasePriority>> {
		const url = `${this.appConfigService.getConfig().webApi}/api2/CasePriorities`;
		const params = this.generateCasePriorityQuery(pageIndex, pageSize, searchTerm);
		return this.http.get(url, { params: params })
			.pipe(catchError(this.errorHandler.handleError<PagingResponse<CasePriority>>(`getCasesWithProcessing with searchTerm=${searchTerm}&pageIndex=${pageIndex}&pageSize=${pageSize}`)));
	}

	setCasePriority(casePriority: CasePriority): Observable<any> {
		const url = `${this.appConfigService.getConfig().webApi}/api2/CasePriorities/${casePriority.caseId}`;
		return this.http.put(url, casePriority)
			.pipe(catchError(this.errorHandler.handleError<CasePriority>(`setCasePriority with caseId=${casePriority.caseId} & Priority=${casePriority.priority}`)));
	}

	private generateCasePriorityQuery(pageIndex: number, pageSize: number, searchTerm: string): HttpParams {
		const params: HttpParams =
			this.setPagingParams(pageIndex, pageSize)
				.set('$count', 'true')
				.set('$orderby', 'caseName');

		if (!searchTerm)
			return params;

		const st = StringUtility.escapeODataFilterString(searchTerm.toLowerCase());
		return params.set('$search', st);
	}

	private setPagingParams(pageIndex: number, pageSize: number): HttpParams {
		const skip = pageIndex * pageSize;
		return new HttpParams()
			.set('$skip', skip.toString())
			.set('$top', pageSize.toString());
	}
}
